"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _react = _interopRequireDefault(require("react"));
var _ScrollLink = require("b2b-components/theme/components/CMS/ScrollLink");
var _classnames = _interopRequireDefault(require("classnames"));
const ANCHOR_TAG_REGEX = /<a\s+href="([^"]+)">([^<]+)<\/a>/;
const Content = _ref => {
  let {
    text,
    className
  } = _ref;
  const anchorTagMatch = ANCHOR_TAG_REGEX.exec(text);
  const [, link, anchorText] = anchorTagMatch || [];
  const isScrollLink = (0, _ScrollLink.getIsScrollLink)(link || '');
  const separator = 'SEPARATOR';
  const resultText = isScrollLink ? text.replace(ANCHOR_TAG_REGEX, separator).split(separator) : text;
  const rootClassName = (0, _classnames.default)(className, 'cds-cms-RichTextEditor');
  if (isScrollLink && Array.isArray(resultText)) {
    const [prevText, nextText] = resultText;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: prevText || ''
      },
      className: rootClassName
    }), /*#__PURE__*/_react.default.createElement(_ScrollLink.ScrollLink, {
      href: link || '',
      className: rootClassName
    }, anchorText), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: nextText || ''
      },
      className: rootClassName
    }));
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text
    },
    className: "cds-cms-RichTextEditor"
  });
};
exports.Content = Content;
//# sourceMappingURL=Content.js.map